// eslint-ignore
export default 
`// No Option
<Select label="No Options">
  <template v-slot:no-options>Sorry mate, no options available</template>
</Select>

// Option Slot
<Select v-model="optionSelected" :value="optionSelected" :options="users" label="Option Slot">
  <template v-slot:option="data">
    <div>
      <b>{{data.item.text}}</b>
      <p>{{data.item.desc}}</p>
    </div>
  </template>
</Select>

// Input Slot
<Select v-model="inputSelected" :value="inputSelected" :options="employees" label="Input Slot">
  <template v-slot:input="data">
    <div>
      <img :src="data.item.img">
      <p>{{data.item.name}}</p>
    </div>
  </template>

  <template v-slot:option="data">
    <div>
      <b>{{data.item.name}}</b>
      <p>{{data.item.position}}</p>
    </div>
  </template>
</Select>


export default {
  components: { Select },

  data () {
    return {
        optionSelected: null,
        inputSelected: null,
        users: [
          { text: 'John Doe', desc: 'Unknown Person', value: '2' },
          { text: 'Kib Beck', desc: 'Versatile Person', value: '3' },
        ],
        employees: [
          { 
            name: 'Kobe Forrosuelo',
            position: 'Front End Developer',
            img: 'https://faces-img.xcdn.link/image-lorem-face-5477.jpg',
            value: '1'
          },
          { 
            name: 'Reyven Biloy',
            position: 'Design Director',
            img: 'https://faces-img.xcdn.link/image-lorem-face-3575.jpg',
            value: '2'
          }
        ]
    }
  }
}`;